<template>
  <div class="team-list-container">
    <div class="list-head">
      <div class="list-head-item">
        {{ $t("user_ID") }}
      </div>
      <div class="list-head-item">
        {{ $t("rebate_amount") }}
      </div>
      <div class="list-head-item">
        {{ $t("registration_time") }}
      </div>
    </div>
    <van-empty v-if="teamList.length == 0" :description="$t('no data')" />
    <template v-for="item in teamList">
      <div class="list-content" v-if="teamList.length > 0" :key="item.id">
        <div class="list-content-item">
          {{ item.id }}
        </div>
        <div class="list-content-item">
          <div v-if="item.income.btc">{{ item.income.btc }}BTC</div>
          <div v-if="item.income.eth">{{ item.income.eth }}ETH</div>
          <div v-if="item.income.usdt">{{ item.income.usdt }}USDT</div>
        </div>
        <div class="list-content-item">
          {{ (item.created_at * 1000) | dateFormat("MM/dd/yyyy hh:mm:ss") }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    teamList: {
      type: Array
    },
  },
};
</script>

<style lang="scss" scoped>
.team-list-container {
  padding: 15px;
  .list-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
  }
  .list-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    border-bottom: 1px solid #ddd;
    &-item {
      flex: 1;
      padding: 10px 0;

      &:nth-child(2) {
        text-align: center;
      }
      &:last-child {
        text-align: right;
      }
    }
  }
}
@media (min-width: 640px) {
  .team-list-container {
    padding: 15px;
    .list-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      font-weight: bold;
    }
    .list-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      border-bottom: 1px solid #ddd;
      &-item {
        flex: 1;
        padding: 10px 0;

        &:nth-child(2) {
          text-align: center;
        }
        &:last-child {
          text-align: right;
        }
      }
    }
  }
}
</style>